import {Component, Inject, OnDestroy, OnInit, OnChanges} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Product } from '../../../../../../../../../models/interface/product/product';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FtthService } from '../../../../../../../../../services/api/ftth/ftth.service';
import { LoaderService } from '../../../../../../../../../core/header-menu/loader/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductDepthLevelCfsActionsComponent } from '../product-depth-level-cfs-actions.component';
import { SimpleFormItem } from 'src/app/models/catalog/catalog-form-item-types.model';
import { CatalogService } from 'src/app/services/api/catalog/catalog.service';

@Component({
  selector: 'app-change-cpe',
  templateUrl: './change-cpe.component.html',
  styleUrls: ['./change-cpe.component.scss']
})
export class ChangeCpeComponent implements OnInit, OnDestroy {

  changeCpeModelGroup: FormGroup;
  newCpeModel: string;
  loading: boolean;
  cpeModels: string[];
  cpeModelsMac: string[] = ['genexis','zte_h3640'];
  isAire: boolean = false;

  private item: Product;
  private subscriptions = new Subscription();

  constructor(
    private catalogService: CatalogService,
    private ftthService: FtthService,
    private loaderService: LoaderService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ProductDepthLevelCfsActionsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      item: Product;
      serviceId: number;
      type: string;
      cpe: string;
      mac: string;
    },
  ) {
  }

  ngOnInit() {
    this.item = this.data.item;
    this.isAire = this.item.specId.includes('NEBA_Aire');
    if (this.data.type !== 'cfs') {
      throw new Error('It must be a CFS');
    }

    this.subscriptions.add(this.loaderService.loading$.subscribe(loading => this.loading = loading));

    this.initForm();
    this.initFormValues();
    this.initCpeModels();

    this.cpeModelNewControl.valueChanges.subscribe(x => {
      this.newCpeModel = x;
    });
  }

  cpeChange() {
    this.newCpeModel = this.cpeModelNewControl.value;
    
  }

  private initForm(): void {
    this.changeCpeModelGroup = this.formBuilder.group({
      cpeModelNew: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
      cpeMac: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
      cpeModel: this.formBuilder.control({ value: '', disabled: true }, Validators.required),
      serviceId: this.formBuilder.control({ value: '', disabled: true }, Validators.required),
    });
  }

  private initFormValues(): void {
    this.serviceIdControl.setValue(this.data.serviceId);
    this.cpeModelControl.setValue(this.data.cpe);
    this.cpeMacControl.setValue(this.data.mac);
  }

  private initCpeModels() {
  
    this.catalogService.getSimpleItemForm(SimpleFormItem.CPE_MODELS).subscribe(
      data => {
        this.cpeModels = [...data, "unknown"];
      },);

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  submit() {
    if (this.changeCpeModelGroup.valid && !this.loading) {
      if (!this.isAire){
        this.ftthService.changeCpe({
          idadministrativo: this.serviceIdControl.value,
          cpeModel: this.newCpeModel,
          cpeMac: this.cpeMacControl.value,
        })
          .subscribe(
            (data) => {
              this.loading = false;
              if (data.resultado === 'OK') {
                this.dialogRef.close(true);
                if (data.descResultado === '') {
                  this.notificationsService.showNotification(this.translateService.instant('CHANGE_CPE.success2'), NotificationLevel.SUCCESS);
                } else {
                  this.notificationsService.showNotification(this.translateService.instant('CHANGE_CPE.success') + ` ${data.descResultado}`, NotificationLevel.SUCCESS);
                }
              } else {
                this.notificationsService.showNotification('ERROR (' + data.resultado + '): ' + data.descResultado, NotificationLevel.ERROR);
              }
            },
            error => {
              this.loading = false;
              this.notificationsService
                .showNotification('ERROR (' + error.error.errorId + '): ' + error.error.errorType, NotificationLevel.ERROR);
            });
        }
      if (this.isAire){
        this.ftthService.changeCpeRetailIntegrated({
          idadministrativo: this.serviceIdControl.value,
          cpeModel: this.newCpeModel,
          cpeMac: this.cpeMacControl.value,
        })
          .subscribe(
            (data) => {
              this.loading = false;
              if (data.resultado === 'OK') {
                this.dialogRef.close(true);
                if (data.descResultado === '') {
                  this.notificationsService.showNotification(this.translateService.instant('CHANGE_CPE.success2'), NotificationLevel.SUCCESS);
                } else {
                  this.notificationsService.showNotification(this.translateService.instant('CHANGE_CPE.success') + ` ${data.descResultado}`, NotificationLevel.SUCCESS);
                }
              } else {
                this.notificationsService.showNotification('ERROR (' + data.resultado + '): ' + data.descResultado, NotificationLevel.ERROR);
              }
            },
            error => {
              this.loading = false;
              this.notificationsService
                .showNotification('ERROR (' + error.error.errorId + '): ' + error.error.errorType, NotificationLevel.ERROR);
            });
        }
    }
  }

  get serviceIdControl(): FormControl {
    return this.changeCpeModelGroup.get('serviceId') as FormControl;
  }

  get cpeModelNewControl(): FormControl {
    return this.changeCpeModelGroup.get('cpeModelNew') as FormControl;
  }

  get cpeModelControl(): FormControl {
    return this.changeCpeModelGroup.get('cpeModel') as FormControl;
  }

  get cpeMacControl(): FormControl {
    return this.changeCpeModelGroup.get('cpeMac') as FormControl;
  }


}
